export default __webpack_public_path__ + "static/media/bg-video.f05fb2c1.mp4";